<div class="home-page" id="home">
    <app-header></app-header>
    <main class="page-content-home">
      <app-intro></app-intro>
      <app-partners></app-partners>
      <app-services></app-services>
    </main>
    <app-footer></app-footer>
</div>
